import type { RootState } from 'client/js/redux';
import { createSelector } from 'reselect';
import type { Link } from '../types/quickLinksTypes';

const EMPTY_ARRAY = [];
const EMPTY_OBJECT = {};

export const getQuickLinksState = (state: RootState) => state.quick_links || EMPTY_OBJECT;

export const getLinkCount: (state: RootState) => number = createSelector(
  getQuickLinksState,
  (quickLinksState) => quickLinksState.link_count || 0
);

export const getLinks: (state: RootState) => Link[] = createSelector(getQuickLinksState, (quickLinksState) =>
  Array.isArray(quickLinksState.links) ? quickLinksState.links : EMPTY_ARRAY
);

export const getUnarchivedLinks: (state: RootState) => Link[] = createSelector(getLinks, (links) =>
  links.filter((link) => !link.archived)
);

export const getLinksLoadingState: (state: RootState) => boolean = createSelector(
  getQuickLinksState,
  (quickLinksState) => quickLinksState.loading
);
